import classNames from 'classnames';
import styles from './calendar-offer-icon.module.scss';

export interface CalendarOfferIconProps {
  /** The class name to apply */
  className?: string;
  /** The accessible name of the icon, it is decorative without one */
  label?: string;
}

const CalendarOfferIcon = ({ className, label }: CalendarOfferIconProps) => {
  return (
    <svg
      aria-hidden={label ? undefined : true}
      aria-label={label}
      className={classNames(styles.component, className)}
      fill="none"
      height="8"
      role={label ? 'img' : undefined}
      viewBox="0 0 8 8"
      width="8"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.81548 0.761782C3.90672 0.634948 4.09328 0.634948 4.18451 0.761782L4.76929 1.57475C4.82397 1.65077 4.91855 1.68569 5.00861 1.66311L5.97176 1.42162C6.12202 1.38394 6.26493 1.50558 6.25445 1.66223L6.18724 2.66628C6.18095 2.76017 6.23128 2.84859 6.31458 2.89001L7.20542 3.333C7.3444 3.40211 7.3768 3.58847 7.2695 3.70163L6.58175 4.42696C6.51744 4.49478 6.49996 4.59532 6.53753 4.68137L6.93923 5.60156C7.0019 5.74512 6.90862 5.909 6.75472 5.92573L5.76823 6.03294C5.67599 6.04296 5.59889 6.10859 5.57314 6.19899L5.29774 7.16582C5.25478 7.31665 5.07947 7.38137 4.95097 7.29384L4.12734 6.73277C4.05032 6.68031 3.94967 6.68031 3.87266 6.73277L3.04902 7.29384C2.92053 7.38137 2.74522 7.31665 2.70225 7.16581L2.42686 6.19899C2.40111 6.10859 2.32401 6.04296 2.23176 6.03294L1.24527 5.92573C1.09137 5.909 0.99809 5.74512 1.06076 5.60156L1.46247 4.68137C1.50003 4.59532 1.48255 4.49478 1.41824 4.42696L0.730491 3.70163C0.623194 3.58847 0.65559 3.40211 0.794572 3.333L1.68542 2.89001C1.76872 2.84859 1.81904 2.76017 1.81276 2.66628L1.74555 1.66223C1.73506 1.50558 1.87797 1.38394 2.02824 1.42162L2.99138 1.66311C3.08144 1.68569 3.17602 1.65077 3.2307 1.57475L3.81548 0.761782Z"
        fill="currentColor"
      />
    </svg>
  );
};

CalendarOfferIcon.displayName = 'CalendarOfferIcon';

export default CalendarOfferIcon;
